import { login, logout, getInfo, ssoTokenLogin } from '@/api/sso/user'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { resetRouter } from '@/router'
import md5 from 'md5'
import { MessageBox, Message } from 'element-ui'
import store from '@/store'

const getDefaultState = () => {
  return {
    token: getToken(),
    name: '',
    avatar: '',
    roles: [],
    permissions: [],
    user: {},
    system: [],
    permissionsAll: {}
  }
}

const state = getDefaultState()

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  },
  SET_USER: (state, user) => {
    state.user = user
  },
  SET_PERMISSIONS: (state, permissions) => {
    state.permissions = permissions
  },
  SET_PERMISSIONS_ALL: (state, permissionsAll) => {
    state.permissionsAll = permissionsAll
  },
  SET_SYSTEM: (state, system) => {
    state.system = system
  }
}

const actions = {
  // user login
  login({ commit }, userInfo) {
    const { username, password, code, uuid } = userInfo
    return new Promise((resolve, reject) => {
      login({ username: username.trim(), password: md5(password), code: code, uuid: uuid }).then(response => {
        if (response.code !== '200') {
          Message.error(response.msg);
          // alert(response.msg)
          reject(response.msg)
          return
        }
        const { data } = response
        commit('SET_TOKEN', data.token)
        setToken(data.token)
        resolve(data)
      }).catch(error => {
        console.info(error)
        reject(error)
      })
    })
  },
  ssoLogin({ commit }, userInfo) {
    const { token } = userInfo
    return new Promise((resolve, reject) => {
      console.log('单点登录Token校验')
      ssoTokenLogin({ username: token }).then(response => {
        if (response.code !== '200') {
          // Message.error(response.message);
          // alert(response.msg)
          resolve()
          return
        }
        const { data } = response
        commit('SET_TOKEN', data.token)
        setToken(data.token)
        resolve(data)
      }).catch(error => {
        console.info(error)
        reject(error)
      })
    })
  },

  getSystem({ commit, state }) {
    return new Promise((resolve, reject) => {
      console.log('获取子系统图标', state.system)
      resolve(state.system)
    })
  },

  getPermissionsAll({ commit, state }, systemType) {
    // if(state.permissionsAll === undefined || state.permissionsAll === '' || state.permissionsAll === 'null'){
    //    getInfo({ commit, state });
    // }
    return new Promise((resolve, reject) => {
      console.log('获取权限', state.permissionsAll)
      resolve(state.permissionsAll)
    })
    // return state.permissionsAll;
  },

  getUser({ commit, state }) {
    // if(state.user === undefined || state.user === '' || state.user === 'null'){
    //    getInfo({ commit, state });
    // }
    return new Promise((resolve, reject) => {
      console.log('获取用户', state.user)
      resolve(state.user)
    })
    // return state.user;
  },

  // get user info
  getInfo({ commit, state }, systemType) {
    return new Promise((resolve, reject) => {
      console.log('调用getInfo，systemType:', systemType)
      getInfo(state.token, systemType).then(response => {
        console.log('getInfo接口返回:', response)
        const { data } = response
        if (!data) {
          MessageBox.alert('你的登录验证失败，请重新登录', '登录失败', {
            confirmButtonText: '重新登录',
            type: 'warning'
          }).then(() => {
            store.dispatch('user/resetToken').then(() => {
              location.reload()
            })
          })
          reject('登录验证失败')
          return
        }

        const { roles, name, avatar, permissions, permissionsAll, user, systems } = data
        console.log('解析用户数据:', { roles, permissions, user })
        // roles must be a non-empty array
        if ((!roles || roles.length <= 0) && (!permissions || permissions.length <= 0)) {
          // reject('getInfo: roles or permissions must be a non-null array!')
          MessageBox.alert('你无权登录系统，请联系系统管理员', '登录失败', {
            confirmButtonText: '重新登录',
            type: 'warning'
          }).then(() => {
            store.dispatch('user/resetToken').then(() => {
              location.reload()
            })
          })
          reject('用户权限不足')
          return
        }

        commit('SET_ROLES', roles)
        commit('SET_NAME', name)
        commit('SET_AVATAR', avatar)
        commit('SET_USER', user)
        commit('SET_PERMISSIONS', permissions || [])
        commit('SET_PERMISSIONS_ALL', permissionsAll)
        commit('SET_SYSTEM', systems)

        resolve(data)
      }).catch(error => {
        console.error('getInfo接口调用失败:', error)
        reject(error)
      })
    })
  },

  // user logout
  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
      logout(state.token).then(() => {
        removeToken() // must remove  token  first
        resetRouter()
        commit('RESET_STATE')
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      removeToken() // must remove  token  first
      commit('RESET_STATE')
      resolve()
    })
  }

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
